import { DataSourcesCta } from 'landing-pages/data-sources/sections/DataSourcesCta/DataSourcesCta';
import { DataSourcesDirectory } from 'landing-pages/data-sources/sections/DataSourcesDirectory/DataSourcesDirectory';
import { DataSourcesHero } from 'landing-pages/data-sources/sections/DataSourcesHero/DataSourcesHero';

import styles from './DataSourcesPage.module.scss';

export const DataSourcesPage = () => {
  return (
    <div className={styles.wrapper}>
      <DataSourcesHero />
      <DataSourcesDirectory />
      <DataSourcesCta />
    </div>
  );
};
